module.exports = __webpack_public_path__ + "media/assets/images/category/Easter@2x-33543578c08d689b1542a46b44f09db9.png";